import React, { FC } from "react";
import { Icon, Tooltip } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { SpecialFilterStatBlock } from "../styled";

import { formatNumber } from "../../../utils/formatNumber";

export const UniqueValues: FC<{ distinctCount?: number }> = ({ distinctCount }) => {
  const { t } = useTranslation("table");

  return (
    <Tooltip content={t("uniqueValues")} arrow placement="top" delay={50}>
      {ref => (
        <SpecialFilterStatBlock ref={ref}>
          <Icon kind="star" disabled />
          {formatNumber(distinctCount ?? 0)}
        </SpecialFilterStatBlock>
      )}
    </Tooltip>
  );
};
